/** Landscape fullscreen video styles (matches App2 CoursePage lesson behavior). */
export const videoElementStylesContain = {
	"& video, & iframe": {
		position: "absolute !important" as const,
		top: "0 !important" as const,
		left: "0 !important" as const,
		width: "100% !important" as const,
		height: "100% !important" as const,
		objectFit: "contain" as const
	},
	"& > div": {
		position: "absolute !important" as const,
		top: "0 !important" as const,
		left: "0 !important" as const,
		width: "100% !important" as const,
		height: "100% !important" as const
	}
};

export const createVideoPlayerStyles = (background: string): Record<string, any> => ({
	top: "0 !important" as const,
	width: "100% !important" as const,
	background: `${background} !important` as const,
	...videoElementStylesContain
});

export const landscapeVideoPlayerBackdropStyles = {
	position: "fixed" as const,
	paddingBottom: 0,
	height: "100vh",
	zIndex: 9999,
	top: 0,
	left: 0,
	right: 0,
	background: "black !important" as const,
	...videoElementStylesContain
};

export const portraitVideoPlayerBackdropStyles = {
	position: "relative !important" as const,
	paddingBottom: "56.25% !important" as const,
	height: "0 !important" as const,
	width: "100% !important" as const,
	background: "transparent !important" as const,
	...videoElementStylesContain
};

/** PageBase-level styles when mobile landscape should show video fullscreen. */
export const landscapePageBaseVideoStyles = (shouldHideUI: boolean): Record<string, any> => ({
	...(!shouldHideUI && {
		"& [class*='videoPlayerBackdrop']": portraitVideoPlayerBackdropStyles,
		"& [class*='videoPlayer']": createVideoPlayerStyles("transparent")
	}),
	...(shouldHideUI && {
		"& [class*='navBar']": {
			display: "none"
		},
		"& [class*='contentContainer']": {
			position: "fixed",
			top: 0,
			height: "100vh",
			overflowY: "hidden",
			zIndex: 9998
		},
		"& [class*='sideMenu']": {
			display: "none"
		},
		"& > [class*='MobileNavBar']": {
			display: "none"
		},
		"& [class*='videoPlayerBackdrop']": landscapeVideoPlayerBackdropStyles,
		"& [class*='videoPlayer']": createVideoPlayerStyles("black")
	})
});

/** Container-level styles for embedded players (e.g. home page modal). */
export const landscapeVideoContainerStyles = {
	position: "fixed" as const,
	top: 0,
	left: 0,
	right: 0,
	height: "100vh",
	zIndex: 9999,
	background: "black",
	"& [class*='videoPlayerBackdrop']": landscapeVideoPlayerBackdropStyles,
	"& [class*='videoPlayer']": createVideoPlayerStyles("black")
};
